import { request } from '@tencent/ppd-base-libs';
import { VoucherItem, ListParamType } from '@/types/voucher';

type ParamsVoucherList = {
  offset: number,
  type: ListParamType,
  limit: number
};

export const fen2yuan = (val) => {
  const re = /^[+|-]?[0-9]+$/;
  let returnVal: string = val;
  if (typeof val !== 'string') {
    returnVal = val.toString();
  }
  return re.test(returnVal) ? (parseFloat(returnVal) / 100).toFixed(2) : '0.00';
};

export async function getVoucherList(data: ParamsVoucherList): Promise<VoucherItem[]> {
  const { offset, type, limit } = data;
  const res = await request.get('https://prom.wechatpay.com.hk/app/promotion/gov_coupons/prom_qry_user_cv_list.cgi', {
    params: {
      type,
      offset,
      limit,
    },
  });
  if (res?.cv_list) {
    return res.cv_list.map(cv => ({
      /** 券批次状态 */
      cvStatus: cv.cv_status,
      /** 消费券状态 */
      transState: cv.trans_state,
      /** 消费券转移状态 */
      ownState: cv.own_state,
      /** 余额 */
      balance: fen2yuan(cv.balance),
      /** 创建时间 */
      createTime: cv.create_time,
      /** 有效期 */
      validTime: cv.valid_time,
      /** 过期时间 */
      expireTime: cv.expire_time,
      /** 用户券ID */
      userCvId: cv.user_cv_id,
      /** 券批次号 */
      cvId: cv.cv_id,
      /** 券logo */
      cvIcon: cv.cv_icon,
      /** 券名字 */
      cvName: cv.cv_name,
      /** 券描述 */
      cvDesc: cv.cv_desc,
      /** 券类型 */
      cvType: cv.cv_type,
      /** 是否推荐该券 */
      recommend: cv.recommend,
      /** 若是主动领取消费券，则该字段是点击领取的时间，被动领取与FcreateTime相同。 */
      receiveTime: cv.receive_time,
      /** 修改时间 */
      modifyTime: cv.modify_time,
      /** 累积实际撤回金额 */
      releaseAmount: cv.release_amount,
      /** 废除渠道 */
      deleteChannel: cv.delete_channel,
      /** 累计已使用金额 */
      totalUsedBal: fen2yuan(cv.total_used_bal),
    }));
  }
  return [];
}
